import { all } from 'redux-saga/effects';
import createSmartFillSaga from '../redux/hotel/smartfill.meta.saga';
import { createHotelSaga, createHotelCheckoutSaga } from './hotel/hotel.saga';
import createMetadataSaga from './metadata/metadata.saga';
import createBookingSaga from './booking/booking.saga';
import createLoyaltyProgramSaga from './loyaltyProgram/loyaltyProgram.saga';
import createAnalyticsSaga from './analytics/analytics.saga';
import createUserSaga from './user/user.saga';
import createFavouritesSaga from './favourites/favourites.saga';
export default function createRootSaga() {
  return function* rootSaga() {
    yield all([
      createHotelSaga(),
      createHotelCheckoutSaga(),
      createMetadataSaga(),
      createBookingSaga(),
      createLoyaltyProgramSaga(),
      createAnalyticsSaga(),
      createUserSaga(),
      createFavouritesSaga(),
      createSmartFillSaga(),
    ]);
  };
}
